import ContentWriteGreyRebrand from '@/assets/image/free-to-pay/content-write-grey-svg/content-write-grey-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const ContentWriteGreySvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'content write grey', ...rest } = props;

  return <Image src={ContentWriteGreyRebrand} alt={alt} {...rest} />;
};
